import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/admin/OutreachBatch";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/admin/outreach-batch/")({
  head: () => routeHead("/admin/outreach-batch/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Page />
  );
}
